
// import React from "react";
// import PropTypes from "prop-types";
// import { Avatar, Box, Typography } from "@mui/material";
// import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
// import YouTubeIcon from "@mui/icons-material/YouTube";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import Tooltip from "@mui/material/Tooltip";
// import MDBox from "components/MDBox";
// import facebookVerifiedIcon from "assets/images/icons/socials/facebook-verified.png";
// import youtubeVerifiedIcon from "assets/images/icons/socials/youtube-verified.png";
// import dayjs from "dayjs";
// import QueryStatsIcon from "@mui/icons-material/QueryStats";
// import youtubeLogoDark from "assets/images/logos/youtube-logo-dark.png";

// const Header = ({ name, platform, profilePictureUrl, verified, link, entityObject, onViewAnalytics }) => { // ✅ Added onViewAnalytics prop
//   const renderPlatformIcon = () => {
//     switch (platform) {
//       case "Facebook":
//         return <FacebookRoundedIcon sx={{ fontSize: 32, color: "#282828", }} />;
//       case "Instagram":
//         return <InstagramIcon sx={{ fontSize: 32, color: "#282828", }} />;
//       case "YouTube":
//         return (
//           <MDBox
//             component="img"
//             src={youtubeLogoDark}
//             alt="YouTube Logo"
//             sx={{
//               width: 20,
//               height: 20,
//               objectFit: "contain",
//               display: "inline-block",
//               mt: "2px",
//             }}
//           />
//         );
//       default:
//         return null;
//     }
//   };

//   const getFormattedDate = () => {
//     const timestamp = entityObject.created_time || entityObject.publishedAt || entityObject.taken_at;
//     return timestamp ? dayjs(timestamp).format("MMM D, YYYY [at] h:mmA") : "Unknown date";
//   };

//   const permalink = entityObject.permalink || entityObject.permalink_url;

//   return (
//     <MDBox
//       display="flex"
//       alignItems="center"
//       px={0.5}
//       py={0.5}
//       gap={1.5}
//       // bgColor="white"
//       sx={{ borderBottom: "1px solid #eee" }}
//     >
//       <Box sx={{ position: "relative", width: 45, height: 45 }}>
//         <Tooltip title={`${name}`} arrow>
//           <a
//             href={link}
//             target="_blank"
//             rel="noopener noreferrer"
//             onClick={(e) => e.stopPropagation()}
//             style={{ display: "inline-block" }}
//           >
//             <Avatar
//               src={profilePictureUrl || "https://via.placeholder.com/150"}
//               sx={{ width: 45, height: 45 }}
//             />
//           </a>
//         </Tooltip>
//         {verified && (
//           <Tooltip title="Verified Profile" arrow>
//             <Box
//               component="img"
//               src={platform === "Facebook" ? facebookVerifiedIcon : platform === "YouTube" ? youtubeVerifiedIcon : null}
//               alt="verified"
//               sx={{ position: "absolute", bottom: 0, right: -8, width: 12, height: 12 }}
//             />
//           </Tooltip>
//         )}
//       </Box>

//       <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
//         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minWidth: 0 }}>
//           <Typography
//             variant="subtitle2"
//             sx={{
//               fontWeight: "bold",
//               fontSize: "0.83rem",
//               lineHeight: 1.5,
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//               minWidth: 0,
//               maxWidth: "100%",
//             }}
//           >
//             {name}
//           </Typography>
//         </Box>
//         <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.72rem", lineHeight: 1.1 }}>
//           {getFormattedDate()}
//         </Typography>
//       </Box>

//       <Box
//         sx={{ display: "flex", alignItems: "center", gap: 1, transform: "translateY(15px)" }}
//       >
//         <Tooltip title={`${platform}`} arrow>
//           {renderPlatformIcon()}
//         </Tooltip>

//         <Tooltip title="View analytics" arrow>
//           <QueryStatsIcon
//             fontSize="small"
//             sx={{ color: "#000", cursor: "pointer" }}
//             onClick={(e) => {
//               e.stopPropagation();
//               if (onViewAnalytics) onViewAnalytics(entityObject); // ✅ Call the handler
//             }}
//           />
//         </Tooltip>
//         <Tooltip title="View original post" arrow>
//           <a
//             href={permalink}
//             target="_blank"
//             rel="noopener noreferrer"
//             onClick={(e) => e.stopPropagation()}
//             style={{ display: "flex", alignItems: "center" }}
//           >
//             <OpenInNewIcon
//               fontSize="small"
//               sx={{ color: "#000", cursor: "pointer" }}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 console.log("Open in new clicked");
//               }}
//             />
//           </a>
//         </Tooltip>
//       </Box>
//     </MDBox>
//   );
// };

// Header.propTypes = {
//   name: PropTypes.string.isRequired,
//   platform: PropTypes.string.isRequired,
//   profilePictureUrl: PropTypes.string,
//   verified: PropTypes.bool,
//   link: PropTypes.string,
//   entityObject: PropTypes.object.isRequired,
//   onViewAnalytics: PropTypes.func, // ✅ Added new prop type
// };

// export default Header;


// // #############################################


import React from "react";
import PropTypes from "prop-types";
import { Avatar, Box, Typography } from "@mui/material";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import facebookVerifiedIcon from "assets/images/icons/socials/facebook-verified.png";
import youtubeVerifiedIcon from "assets/images/icons/socials/youtube-verified.png";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ✅ Import the UTC plugin
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import youtubeLogoDark from "assets/images/logos/youtube-logo-dark.png";

dayjs.extend(utc); // ✅ Tell dayjs to use the UTC plugin

const Header = ({ name, platform, profilePictureUrl, verified, link, entityObject, onViewAnalytics }) => {
  const renderPlatformIcon = () => {
    switch (platform) {
      case "Facebook":
        return <FacebookRoundedIcon sx={{ fontSize: 32, color: "#282828", }} />;
      case "Instagram":
        return <InstagramIcon sx={{ fontSize: 32, color: "#282828", }} />;
      case "YouTube":
        return (
          <MDBox
            component="img"
            src={youtubeLogoDark}
            alt="YouTube Logo"
            sx={{
              width: 20,
              height: 20,
              objectFit: "contain",
              display: "inline-block",
              mt: "2px",
            }}
          />
        );
      default:
        return null;
    }
  };

  // ⬇️=========================================
  // ⬇️ THIS FUNCTION IS UPDATED
  // ⬇️=========================================
  const getFormattedDate = () => {
    const timestamp = entityObject.created_time || entityObject.publishedAt || entityObject.taken_at;
    if (!timestamp) return "Unknown date";
    
    // Use dayjs.utc() to parse the time and keep it in UTC.
    // Add [UTC] to the format string to label it.
    return dayjs.utc(timestamp).format("MMM D, YYYY [at] h:mmA [UTC]");
  };
  // ⬆️=========================================
  // ⬆️ END OF UPDATE
  // ⬆️=========================================

  const permalink = entityObject.permalink || entityObject.permalink_url;

  return (
    <MDBox
      display="flex"
      alignItems="center"
      px={0.5}
      py={0.5}
      gap={1}
      // bgColor="white"
      sx={{ borderBottom: "1px solid #eee" }}
    >
      <Box sx={{ position: "relative", width: 45, height: 45 }}>
        <Tooltip title={`${name}`} arrow>
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            style={{ display: "inline-block" }}
          >
            <Avatar
              src={profilePictureUrl || "https://via.placeholder.com/150"}
              sx={{ width: 45, height: 45 }}
            />
          </a>
        </Tooltip>
        {verified && (
          <Tooltip title="Verified Profile" arrow>
            <Box
              component="img"
              src={platform === "Facebook" ? facebookVerifiedIcon : platform === "YouTube" ? youtubeVerifiedIcon : null}
              alt="verified"
              sx={{ position: "absolute", bottom: 0, right: -6, width: 12, height: 12 }}
            />
          </Tooltip>
        )}
      </Box>

      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        <Box sx={{ display: "flex", alignItems: "left", justifyContent: "left", minWidth: 0 }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: "bold",
              fontSize: "0.83rem",
              lineHeight: 1.5,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              minWidth: 0,
              maxWidth: "100%",
            }}
          >
            {name}
          </Typography>
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.68rem", lineHeight: 1.1 }}>
          {getFormattedDate()}
        </Typography>
      </Box>

      <Box
        sx={{ display: "flex", alignItems: "center", gap: 1, transform: "translateY(10px)" }}
      >
        <Tooltip title={`${platform}`} arrow>
          {renderPlatformIcon()}
        </Tooltip>

        <Tooltip title="View analytics" arrow>
          <QueryStatsIcon
            fontSize="small"
            sx={{ color: "#000", cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              if (onViewAnalytics) onViewAnalytics(entityObject); // ✅ Call the handler
            }}
          />
        </Tooltip>
        <Tooltip title="View original post" arrow>
          <a
            href={permalink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            style={{ display: "flex", alignItems: "center" }}
          >
            <OpenInNewIcon
              fontSize="small"
              sx={{ color: "#000", cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                console.log("Open in new clicked");
              }}
            />
          </a>
        </Tooltip>
      </Box>
    </MDBox>
  );
};

Header.propTypes = {
  name: PropTypes.string.isRequired,
  platform: PropTypes.string.isRequired,
  profilePictureUrl: PropTypes.string,
  verified: PropTypes.bool,
  link: PropTypes.string,
  entityObject: PropTypes.object.isRequired,
  onViewAnalytics: PropTypes.func,
};

export default Header;